var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowConfigContext from '../../context/window-config-context';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle } from '../../helpers/styles';
import useFormItem from '../../hooks/useFormItem';
import ChildItemWidget from '../ChildItemWidget';
import Item from '../Item';
export var StyledComboBox = styled.select.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  background: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-top-color: ", ";\n  border-left-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  outline: ", ";\n  height: ", ";\n  font-family: ", ";\n"], ["\n  ",
    "\n  color: ", ";\n  background: ", ";\n  background-color: ",
    ";\n  border: ", ";\n  border-radius: ", ";\n  border-top-color: ",
    ";\n  border-left-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  outline: ", ";\n  height: ", ";\n  font-family: ", ";\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(__assign(__assign({}, geometry), { height: (geometry && geometry.height) || 'auto' }));
}, function (_a) {
    var windowTheme = _a.windowTheme, color = _a.color;
    return color !== null && color !== void 0 ? color : windowTheme.comboBox.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.outline;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.comboBox.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.window.fontFamily;
});
function ComboBox(props) {
    var identifier = props.identifier, attributes = props.attributes, onChange = props.onChange, windowId = props.windowId, system = props.system, children = props.children, restProps = __rest(props, ["identifier", "attributes", "onChange", "windowId", "system", "children"]);
    var formItemProps = useFormItem(identifier, {
        commitOnOnChange: true,
    });
    var fields = useContext(WindowStateContext).fields;
    var _onDropdownClick = useContext(WindowEventContext)._onDropdownClick;
    var config = useContext(WindowConfigContext);
    var items = fields[identifier + "_choices"] || [];
    var handleDropdownClick = function () {
        console.log('clicked dropdown container');
        config.isBuilder && _onDropdownClick(identifier);
    };
    var selectedItem = items.find(function (item) { return item.text === formItemProps.value; });
    return (React.createElement(StyledComboBox, __assign({ geometry: attributes.geometry }, restProps, formItemProps, { color: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.fontColor, onClick: handleDropdownClick }),
        React.createElement("option", { value: "" }),
        items.length ? (items.map(function (item) { return (React.createElement(Item, { parentWidget: restProps, type: "item", fontColor: item.fontColor, backgroundColor: item.backgroundColor, attributes: { text: item.text } })); })) : (React.createElement(ChildItemWidget, __assign({ attributes: attributes }, restProps)))));
}
export default ComboBox;
var templateObject_1;
//# sourceMappingURL=index.js.map